import { render, staticRenderFns } from "./notificationsDropdown.vue?vue&type=template&id=1218f444"
import script from "./notificationsDropdown.vue?vue&type=script&lang=js"
export * from "./notificationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./notificationsDropdown.vue?vue&type=style&index=0&id=1218f444&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports